export const DURATION = 8;

export const OIL_DESK_DROP_ZONE = {
    bottom: 173,
    right: 318,
    width: 90,
    height: 90,
};

export const OIL_DROP_ZONE = {
    bottom: 300,
    right: 162,
    width: 60,
    height: 60,
};

export const phrases = [
    {
        id: 'phrase_0',
        text:'Осознанный выбор направления',
        bg: <svg width="100%" height="100%" viewBox="0 0 260 100" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g filter="url(#filter0_f_7_56614)" data-figma-bg-blur-radius="6.84513">
            <path d="M229.381 49.2068C276.478 94.4463 182.61 69.9975 117.54 80.2718C36.3823 86.559 -0.738085 74.8766 25.3814 49.2068C4.04308 20.1966 32.7727 13.4634 117.54 18.7718C219.395 15.8965 258.022 21.7186 229.381 49.2068Z" fill="white" fill-opacity="0.9"/>
            </g>
            <defs>
            <filter id="filter0_f_7_56614" x="2.47955e-05" y="0.000452042" width="259.238" height="99.0557" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
            <feFlood flood-opacity="0" result="BackgroundImageFix"/>
            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
            <feGaussianBlur stdDeviation="8.55641" result="effect1_foregroundBlur_7_56614"/>
            </filter>
            <clipPath id="bgblur_0_7_56614_clip_path" transform="translate(-2.47955e-05 -0.000452042)"><path d="M229.381 49.2068C276.478 94.4463 182.61 69.9975 117.54 80.2718C36.3823 86.559 -0.738085 74.8766 25.3814 49.2068C4.04308 20.1966 32.7727 13.4634 117.54 18.7718C219.395 15.8965 258.022 21.7186 229.381 49.2068Z"/>
            </clipPath></defs>
        </svg>,
        width: 260,
    },
    {
        id: 'phrase_1',
        text:'Лидерский потенциал',
        bg: <svg width="100%" height="100%" viewBox="0 0 188 100" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g filter="url(#filter0_f_7_57610)" data-figma-bg-blur-radius="6.84513">
            <path d="M161.448 49.2908C193.471 94.6487 129.645 70.1359 85.3998 80.4371C30.2153 86.7408 4.97482 75.0277 22.7351 49.2908C8.22583 20.2046 27.7609 13.4539 85.3992 18.7761C154.657 15.8933 180.922 21.7306 161.448 49.2908Z" fill="white" fill-opacity="0.9"/>
            </g>
            <defs>
            <filter id="filter0_f_7_57610" x="-3.62396e-05" y="0.000452042" width="187.226" height="99.2257" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
            <feFlood flood-opacity="0" result="BackgroundImageFix"/>
            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
            <feGaussianBlur stdDeviation="8.55641" result="effect1_foregroundBlur_7_57610"/>
            </filter>
            <clipPath id="bgblur_0_7_57610_clip_path" transform="translate(3.62396e-05 -0.000452042)"><path d="M161.448 49.2908C193.471 94.6487 129.645 70.1359 85.3998 80.4371C30.2153 86.7408 4.97482 75.0277 22.7351 49.2908C8.22583 20.2046 27.7609 13.4539 85.3992 18.7761C154.657 15.8933 180.922 21.7306 161.448 49.2908Z"/>
            </clipPath></defs>
        </svg>,  
        width: 188,
    },
    {
        id: 'phrase_2',
        text:'Готовность к вызовам и ответственности',
        bg: <svg width="100%" height="100%" viewBox="0 0 285 100" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g filter="url(#filter0_f_7_58607)" data-figma-bg-blur-radius="6.84513">
            <path d="M252.954 49.2908C305.28 94.6487 200.988 70.1359 128.693 80.4371C38.5221 86.7408 -2.7205 75.0277 26.2996 49.2908C2.59161 20.2046 34.5116 13.4539 128.692 18.7761C241.858 15.8933 284.775 21.7306 252.954 49.2908Z" fill="white" fill-opacity="0.9"/>
            </g>
            <defs>
            <filter id="filter0_f_7_58607" x="-3.62396e-05" y="0.000452042" width="284.226" height="99.2257" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
            <feFlood flood-opacity="0" result="BackgroundImageFix"/>
            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
            <feGaussianBlur stdDeviation="8.55641" result="effect1_foregroundBlur_7_58607"/>
            </filter>
            <clipPath id="bgblur_0_7_58607_clip_path" transform="translate(3.62396e-05 -0.000452042)"><path d="M252.954 49.2908C305.28 94.6487 200.988 70.1359 128.693 80.4371C38.5221 86.7408 -2.7205 75.0277 26.2996 49.2908C2.59161 20.2046 34.5116 13.4539 128.692 18.7761C241.858 15.8933 284.775 21.7306 252.954 49.2908Z"/>
            </clipPath></defs>
        </svg>,
        width: 285,
    },
]